const rootElement = document.documentElement;
const computedStyles = getComputedStyle(rootElement);

export const primaryColor = computedStyles.getPropertyValue("--primary-color");
export const secondaryColor = computedStyles.getPropertyValue("--secondary-color");
export const lineDark = computedStyles.getPropertyValue("--linedark");
export const lineLight = computedStyles.getPropertyValue("--linelight");

export const white = computedStyles.getPropertyValue("--white");
export const brown = computedStyles.getPropertyValue("--brown");

export const activeLineW = computedStyles.getPropertyValue("--active-line-width").replace("px", "");
export const defaultLineW = computedStyles.getPropertyValue("--default-line-width").replace("px", "");

export const duskBG = computedStyles.getPropertyValue("--dusk-bg");
export const dayBG = computedStyles.getPropertyValue("--day-bg");
export const dawnBG = computedStyles.getPropertyValue("--dawn-bg");
export const nightBG = computedStyles.getPropertyValue("--night-bg");

export const walla = computedStyles.getPropertyValue("--walla");
export const picnic = computedStyles.getPropertyValue("--titleFont");
